/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
// material
import { Link } from '@insticator/insticator-ui'; // iui-material

// styles
import injectSheet from 'react-jss';
import styles from 'material/expandablesection/sectiongroup/sectiongroup_styles';


const SectionGroup = (props) => {
  const {
    row,
    secondary
  } = props
  return <div className={`sectiongroup ${props.classes.sectiongroup} ${secondary ? 'secondary' : ''} ${row ? 'row' : ''}`}>
    {props.children}
  </div>
}

export default injectSheet(styles)(SectionGroup)